import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import {
  FormEnums,
  NewFormButtonText,
} from "app/services/api/types/forms/enums/FormEnums";
import { View } from "ui/atoms/view";
import { ButtonIcon, ButtonLink, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { AssessmentHistoryTemplate } from "app/features/reporting/templates/AssessmentHistoryTemplate";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { Text } from "react-native";

export function VitalSignsScreen() {
  const { resident } = useResidentContext();

  return (
    <View className="resident-container">
      <View className="flex-row justify-between mb-4">
        <Text className="text-lg font-semibold">Parameters</Text>
        <PermissionCheck permission={PermissionsEnums.FILL_FORM}>
          <ButtonLink href={`/residents/${resident?.id}/parameters/add`}>
            <ButtonIcon as={AddIcon} />
            <ButtonText>{NewFormButtonText[FormEnums.VITAL_SIGNS]}</ButtonText>
          </ButtonLink>
        </PermissionCheck>
      </View>
      <AssessmentHistoryTemplate
        tag={FormEnums.VITAL_SIGNS}
        residentId={resident?.id}
      />
    </View>
  );
}
